// extracted by mini-css-extract-plugin
export var carrierIcon = "_vk-0";
export var carrierLogo = "_vk-1";
export var detailsSection = "_vk-2";